var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconChalkboardSimple = function SvgIconChalkboardSimple(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 5.5V15a1 1 0 1 1-2 0V5.25A1.75 1.75 0 0 1 3.75 3.5h16.5A1.75 1.75 0 0 1 22 5.25V15a1 1 0 1 1-2 0V5.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M.5 18.75a1 1 0 0 1 1-1h8.75V15a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v2.75h4.25a1 1 0 1 1 0 2h-21a1 1 0 0 1-1-1m11.75-1h4V16h-4z",
    clipRule: "evenodd"
  }))));
};
export default SvgIconChalkboardSimple;